export async function *batchAsyncIteratorAdapter<T>(
	baseIterator: AsyncIterableIterator<T>,
	batchSize: number,
): AsyncIterableIterator<T[]> {
	let batch: T[] = [];

	for await (const item of baseIterator) {
		batch.push(item);

		if (batch.length === batchSize) {
			yield batch;

			batch = [];
		}
	}

	if (batch.length > 0)
		yield batch;
}
